import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';
import { setItemToLocalStorage } from 'helpers/localStorage';

import OList from 'components/Lists/OList';
import SaleDayPopup from '../components/popups/SaleDayPopup';

const NsoC = ({ setCurrentPage }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('nsoB'), []);

  const optionOneHandler = (e) => {
    e.stopPropagation();
    setCurrentPage('nsoH');
  };

  const optionTwoHandler = () => {
    setItemToLocalStorage('EcameFrom', 'nsoC');
    setLastPage('nsoC');
    setCurrentPage('nsoI');
  };

  const openPopup = (e) => {
    e.stopPropagation();
    setIsPopupOpen(true);
  };

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <h1 className='page-heading text-center mb-5'>
        Awesome!
        <br />
        What do you intend to do with your stocks?
      </h1>

      <OList colorsOrder='rbo'>
        <li onClick={optionOneHandler}>
          <div>
            I elected to do a{' '}
            <span className='color-black' onClick={(e) => openPopup(e)}>
              same-day sale
            </span>{' '}
            (aka cashless exercise).
          </div>
        </li>
        <li onClick={optionTwoHandler}>I intend to hold onto my stocks and sell at a later date.</li>
      </OList>

      <SaleDayPopup isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen} />
    </div>
  );
};

NsoC.propTypes = {
  setCurrentPage: PropTypes.func
};

export default NsoC;
